import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';
import { Project } from 'types/data/project.t';

// Define a type for the slice state
interface ProjectsState {
  value: Project[];
}

// Define the initial state using that type
const initialState: ProjectsState = {
  value: []
};

export const projectsSlice = createSlice({
  name: 'projects',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    addProject: (state, action: PayloadAction<Project>) => {
      state.value = [...state.value, action.payload];
    },
    removeProject: (state, action: PayloadAction<number>) => {
      state.value = state.value.filter(p => p.id !== action.payload);
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateProject: (state, action: PayloadAction<Project>) => {
      state.value = state.value.map(p => (p.id === action.payload.id ? action.payload : p));
    },
    updateProjects: (state, action: PayloadAction<Project[]>) => {
      state.value = action.payload;
    }
  }
});

export const { addProject, removeProject, updateProject, updateProjects } = projectsSlice.actions;

//selects all active projects
export const selectProjects = (state: RootState) => state.projects.value;

export default projectsSlice.reducer;
